import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=11081bca&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11081bca')) {
      api.createRecord('11081bca', component.options)
    } else {
      api.reload('11081bca', component.options)
    }
    module.hot.accept("./Price.vue?vue&type=template&id=11081bca&", function () {
      api.rerender('11081bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/requests/edit/Price.vue"
export default component.exports